import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

const NavbarDropdown = ({ label, options, dataCy }) => (
  <UncontrolledDropdown nav inNavbar>
    <DropdownToggle nav className="navbar-dropdown-title" data-cy={dataCy}>
      <div className="navbar-dropdown-title-text">{label}</div>
    </DropdownToggle>
    {options.length > 0 && (
      <DropdownMenu right className="navbar-dropdown">
        {options.map((option, index) => {
          if (option.type === 'windows-link') {
            return (
              <a
                key={index}
                href={option.link}
                target="_blank"
                data-cy={option.dataCy}
              >
                <DropdownItem className="navbar-dropdown-item">
                  {option.label}
                </DropdownItem>
              </a>
            );
          }
          return (
            <Link key={index} to={option.link}>
              <DropdownItem
                className="navbar-dropdown-item"
                data-cy={option.dataCy}
              >
                {option.label}
              </DropdownItem>
            </Link>
          );
        })}
      </DropdownMenu>
    )}
  </UncontrolledDropdown>
);

NavbarDropdown.defaultProps = {
  options: [],
};

NavbarDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()),
  dataCy: PropTypes.string,
};

export default NavbarDropdown;
